// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__RBYXP","header":"ReportDetails_header__13ZeW","title":"ReportDetails_title__2Hl3u","left":"ReportDetails_left__3Xpv1"};